<template>
  <pop-up-window
    :show="this.$store.state.viewUblDetail"
    :showClose="false"
    class="doc-statuses-popup"
    additional-info=""
    :positionFixed="true"
    :position-absolute="false"
    :stickToScrollPosition="true"
    :width60="true"
  >
    <template #title>
      <h1 class="text-2xl">{{ $t("ubl.viewUblDetail") }}</h1>
      <h2>{{ ublDetail.id }}</h2>
      <h2
        v-if="
          userGroups.optipostNames.includes(
            this.$store.state.currentUserData.data.group,
          )
        "
      >
        {{ ublDetail.docId }}
      </h2>
    </template>
    <template #content>
      <div v-if="ublDetail.edi" class="divider container">
        <h2 class="edi-provider">
          {{ $t("documentDetail.documentStatusesInfo.ediProvider") }}
          {{ ublDetail.ediProvider }}
        </h2>
        <div v-for="(item, index) in ediStatuses" :key="index">
          <div>
            <div
              v-if="
                (ublDetail.messageType === 'InvoiceResponse' &&
                  item.status !== 'Rejected') ||
                ublDetail.messageType !== 'InvoiceResponse'
              "
              style="display: flex; flex-direction: row; align-items: center"
            >
              <span
                class="material-icons"
                style="padding-right: 0; font-size: 21px"
                :style="{ color: item.error ? 'darkred' : '#215893' }"
              >
                error_outline
              </span>
              <span class="description">{{ item.status }}</span>
              <i class="icon-calendar" style="padding: 0"></i>
              <span class="description">{{ item.time }}</span>
            </div>
            <div
              v-if="item.message || index === ediStatuses.length - 1"
              class="flex flex-row ml-2"
            >
              <p>
                <span
                  v-if="
                    item.message === undefined &&
                    ublDetail.imrStatus !== undefined
                  "
                  >{{ $t("ubl.imrStatus.title") }}</span
                >
                {{ $t(`ubl.imrStatus.${ublDetail.imrStatus?.toLowerCase()}`) }}
              </p>

              <p v-if="item.message" class="description">
                <span v-if="ublDetail.imrStatus !== undefined">-</span>
                {{ item.message }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <p v-if="invoiceResponseStatusKey != null" class="flex flex-row ml-2">
        {{ $t("ubl.status.title") }}
        {{ $t(`ubl.status.${invoiceResponseStatusKey}`) }}
      </p>

      <div class="grid grid-rows-1 justify-items-center my-6 grey-top-border">
        <div>
          <button
            class="btn custom-button shadow-md mr-2 showStatuses text-popup"
            @click="close"
          >
            {{ $t("buttons.close") }}
          </button>
        </div>
      </div>
    </template>
  </pop-up-window>
</template>

<script>
import PopUpWindow from "../UI/PopUpWindow";
import i18n from "../../i18n";
import moment from "moment";
import userGroups from "../../userGoups";

export default {
  name: "ViewUblDetail",
  components: { PopUpWindow },
  computed: {
    userGroups() {
      return userGroups;
    },
    ublDetail() {
      return this.$store.state.ublDocumentData;
    },
    invoiceResponseStatusKey() {
      const status = this.ublDetail.invoiceResponseStatus;
      if (status == null) return null;
      const key = this.snakeToCamelCase(status);
      return i18n.t(`ubl.status.${key}`) ? key : null;
    },
    ediStatuses() {
      let ediStatuses = [];

      this.ublDetail.edi.forEach((status) => {
        let time;
        if (typeof status.time === "object") {
          time = moment(status.time).format("DD/MM/yyyy HH:mm:ss");
        } else {
          time = moment(status.time, "DD/MM/YYYY h:mm:ss A").format(
            "DD/MM/YYYY HH:mm:ss",
          );
        }

        const ediKey = `documentDetail.documentStatusesInfo.ediStatuses.${this.snakeToCamelCase(status.status)}`;
        let tempItem = {
          time: time,
          status: i18n.t(ediKey, { provider: this.ublDetail.ediProvider }),
          error: false,
        };

        if (status.message) {
          tempItem.message = status.message;
        }

        if (status.status === "FORWARDED" || status.forwardedTo) {
          tempItem.status = i18n.t(ediKey);
          if (status.forwardedTo) {
            let key = `documentDetail.documentStatusesInfo.ediStatuses.forwardedTo.${this.snakeToCamelCase(status.forwardedTo)}`;
            if (status.forwardedTo === "email" && status.email) {
              tempItem.status = `${tempItem.status} ${status.email}`;
            } else if (i18n.t(key)) {
              tempItem.status = `${tempItem.status} ${i18n.t(key)}`;
            } else tempItem.status = `${tempItem.status} ${status.forwardedTo}`;
          }
          tempItem.error = false;
        }

        switch (status.status) {
          case "ERROR":
          case "NOT_SENT":
          case "REJECTED":
            tempItem.error = true;
        }

        ediStatuses.push(tempItem);
      });
      return ediStatuses;
    },
  },
  methods: {
    snakeToCamelCase(str) {
      return str.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    },
    close() {
      this.$store.commit("setUblDocumentData", {});
      this.$store.commit("setViewUblDetail", false);
    },
  },
};
</script>

<style scoped>
.divider {
  margin-top: calc(1 * var(--generalPaddings));
}

.description {
  color: var(--theme-primary-500);
  padding-left: 5px;
  font-size: 14px;
  padding-right: 5px;
}

i {
  color: var(--infoColor);
  padding-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}
</style>
